export const usePdfReadWithOpenInvoice = window.campaignFlags?.usePdfReadWithOpenInvoice;
export const disabledInvoiceUseLoadEvent = window.campaignFlags?.disabledInvoiceUseLoadEvent;
export const enableOpenInvoiceCheckout = window.campaignFlags?.enableOpenInvoiceCheckout;
export const useZoomUIAppendToBody = window.campaignFlags?.useZoomUIAppendToBody;
